<template>
  <div class="not-found">
    <h1>404</h1>
    <p>抱歉，您访问的页面不存在</p>
    <!-- <router-link to="/">返回首页</router-link> -->
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}

h1 {
  font-size: 72px;
  margin-bottom: 20px;
  color: #333;
}

p {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

a {
  color: #409EFF;
  text-decoration: none;
  font-size: 16px;
}

a:hover {
  text-decoration: underline;
}
</style>

